<form [formGroup]="form">
  <p-datepicker
  appendTo="body"
  [locale]="se"
  [showButtonBar]="true"
  [monthNavigator]="true"
  [showWeek]="true"
  [inputStyle]="{'max-width':'110px'}"
  [yearNavigator]="true"
  yearRange="1720:2030"
  dateFormat="yy-mm-dd"
  formControlName="{{formName}}"
  [readonlyInput]="false"
  (onSelect)="changedDate($event)">
  </p-datepicker>
  </form>
